/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiInteractionRecordItem } from '../models/AiInteractionRecordItem';
import type { aiResponse } from '../models/aiResponse';
import type { logRefTable } from '../models/logRefTable';
import type { meta } from '../models/meta';
import { request as __request } from '../core/request';

export class OnvivaiService {

    /**
     * Create a new AI interaction log
     * Create a new AI interaction log
     * @result AiInteractionRecordItem successful operation
     * @throws ApiError
     */
    public static async createAiInteraction({
        requestBody,
    }: {
        /** AiInteraction object to be created **/
        requestBody: AiInteractionRecordItem,
    }): Promise<AiInteractionRecordItem> {
        const result = await __request({
            method: 'POST',
            path: `/server/onvivai/ai-interaction`,
            body: requestBody,
            errors: {
                400: `Error: Update Failed`,
                403: `Error: Forbidden`,
                404: `Error: Not Found`,
                422: `Error: Unprocessable Entity`,
            },
        });
        return result.body;
    }

    /**
     * Get all ai-interaction
     * Returns one or more matching records
     * @result any successful operation
     * @throws ApiError
     */
    public static async getAiInteractionList({
        page = 1,
        pageSize = 10,
        sort,
    }: {
        /** Page to begin results at **/
        page?: number,
        /** Number of results per page **/
        pageSize?: number,
        /** Sort Options - Comma delimited list of key:order. order optional - default ASC  **/
        sort?: string,
    }): Promise<{
        data?: Array<AiInteractionRecordItem>,
        meta?: meta,
    }> {
        const result = await __request({
            method: 'GET',
            path: `/server/onvivai/ai-interaction/list`,
            query: {
                'page': page,
                'pageSize': pageSize,
                'sort': sort,
            },
            errors: {
                403: `Error: Forbidden`,
                422: `Error: Unprocessable Entity`,
            },
        });
        return result.body;
    }

    /**
     * Get suggestions
     * Send to AI for suggestions
     * @result aiResponse successful operation
     * @throws ApiError
     */
    public static async getAiSuggestion({
        requestBody,
    }: {
        /** Target **/
        requestBody: {
            logRefTable?: logRefTable,
            /**
             * Reference Field ID
             */
            logRefId?: number,
            /**
             * Target for AI
             */
            target?: 'subject' | 'question' | 'question_and_type' | 'generate_questions, generate_answers' | 'report_key_insights' | 'report_emerging_questions' | 'report_takeaways' | 'report_recommendations_followup' | 'report_panel_followup_questions',
            /**
             * Text AI
             */
            text?: string,
        },
    }): Promise<aiResponse> {
        const result = await __request({
            method: 'POST',
            path: `/server/onvivai/suggestion`,
            body: requestBody,
            errors: {
                400: `Error: Update Failed`,
                403: `Error: Forbidden`,
                422: `Error: Unprocessable Entity`,
            },
        });
        return result.body;
    }

}